/**
 * Payment system purposes.
 * Used by SumUp payment logic.
 */
export enum SumUpPaymentPurpose {
	CHECKOUT = "CHECKOUT",
	SETUP_RECURRING_PAYMENT = "SETUP_RECURRING_PAYMENT"
}
